"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _default24 = _interopDefault(require("ramda/src/__")),
  _default23 = _interopDefault(require("ramda/src/contains")),
  _default22 = _interopDefault(require("ramda/src/partial")),
  _default21 = _interopDefault(require("ramda/src/pipe")),
  _default20 = _interopDefault(require("ramda/src/keys")),
  _default19 = _interopDefault(require("ramda/src/forEach")),
  _default18 = _interopDefault(require("ramda/src/dissoc")),
  _default17 = _interopDefault(require("ramda/src/merge")),
  _default16 = _interopDefault(require("ramda/src/prop")),
  _default15 = _interopDefault(require("ramda/src/always")),
  _default14 = _interopDefault(require("ramda/src/ifElse")),
  _default13 = _interopDefault(require("ramda/src/propSatisfies")),
  _default12 = _interopDefault(require("ramda/src/propIs")),
  _default11 = _interopDefault(require("ramda/src/has")),
  _default10 = _interopDefault(require("ramda/src/complement")),
  _default9 = _interopDefault(require("ramda/src/isEmpty")),
  _default8 = _interopDefault(require("ramda/src/anyPass")),
  _default7 = _interopDefault(require("ramda/src/gte")),
  _default6 = _interopDefault(require("ramda/src/curry")),
  _default5 = _interopDefault(require("ramda/src/T")),
  _default4 = _interopDefault(require("ramda/src/is")),
  _default3 = _interopDefault(require("ramda/src/identity")),
  _default2 = _interopDefault(require("ramda/src/isNil")),
  _default = _interopDefault(require("ramda/src/cond")),
  axios = _interopDefault(require("axios")),
  _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  };
Function.prototype.$asyncbind = function e(t, r) {
  function n() {
    return a.apply(t, arguments);
  }
  Function.prototype.$asyncbind || Object.defineProperty(Function.prototype, "$asyncbind", {
    value: e,
    enumerable: !1,
    configurable: !0,
    writable: !0
  }), e.trampoline || (e.trampoline = function (e, t, r, n, a) {
    return function u(i) {
      for (; i;) {
        if (i.then) return i = i.then(u, n), a ? void 0 : i;
        try {
          if (i.pop) {
            if (i.length) return i.pop() ? t.call(e) : i;
            i = r;
          } else i = i.call(e);
        } catch (e) {
          return n(e);
        }
      }
    };
  }), e.LazyThenable || (e.LazyThenable = function () {
    function e(e) {
      return e && e instanceof Object && "function" == typeof e.then;
    }
    function t(r, n, a) {
      try {
        var u = a ? a(n) : n;
        if (r === u) return r.reject(new TypeError("Promise resolution loop"));
        e(u) ? u.then(function (e) {
          t(r, e);
        }, function (e) {
          r.reject(e);
        }) : r.resolve(u);
      } catch (e) {
        r.reject(e);
      }
    }
    function r() {}
    function n(e) {}
    function a(e, t) {
      this.resolve = e, this.reject = t;
    }
    function u(n, a) {
      var u = new r();
      try {
        this._resolver(function (r) {
          return e(r) ? r.then(n, a) : t(u, r, n);
        }, function (e) {
          t(u, e, a);
        });
      } catch (e) {
        t(u, e, a);
      }
      return u;
    }
    function i(e) {
      this._resolver = e, this.then = u;
    }
    return r.prototype = {
      resolve: n,
      reject: n,
      then: a
    }, i.resolve = function (e) {
      return i.isThenable(e) ? e : {
        then: function then(t) {
          return t(e);
        }
      };
    }, i.isThenable = e, i;
  }(), e.EagerThenable = e.Thenable = (e.EagerThenableFactory = function (e) {
    function t(e) {
      if (e) {
        var t = this;
        e(function (e) {
          t.resolve(e);
        }, function (e) {
          t.reject(e);
        });
      }
    }
    function r(e, t) {
      if ("function" == typeof e.y) try {
        var r = e.y.call(void 0, t);
        e.p.resolve(r);
      } catch (t) {
        e.p.reject(t);
      } else e.p.resolve(t);
    }
    function n(e, t) {
      if ("function" == typeof e.n) try {
        var r = e.n.call(void 0, t);
        e.p.resolve(r);
      } catch (t) {
        e.p.reject(t);
      } else e.p.reject(t);
    }
    e = e || "object" === ("undefined" == typeof process ? "undefined" : _typeof(process)) && process.nextTick || "function" == typeof setImmediate && setImmediate || function (e) {
      setTimeout(e, 0);
    };
    var a = function () {
      function t() {
        for (; r.length - n;) {
          try {
            r[n]();
          } catch (e) {}
          r[n++] = void 0, n === a && (r.splice(0, a), n = 0);
        }
      }
      var r = [],
        n = 0,
        a = 1024;
      return function (a) {
        r.push(a), r.length - n === 1 && e(t);
      };
    }();
    return t.prototype = {
      resolve: function resolve(e) {
        if (void 0 === this.state) {
          if (e === this) return this.reject(new TypeError("Attempt to resolve promise with self"));
          var t = this;
          if (e && ("function" == typeof e || "object" === ("undefined" == typeof e ? "undefined" : _typeof(e)))) try {
            var n = 0,
              u = e.then;
            if ("function" == typeof u) return void u.call(e, function (e) {
              n++ || t.resolve(e);
            }, function (e) {
              n++ || t.reject(e);
            });
          } catch (e) {
            return void (n || this.reject(e));
          }
          this.state = r, this.v = e, t.c && a(function () {
            for (var n = 0, a = t.c.length; n < a; n++) r(t.c[n], e);
          });
        }
      },
      reject: function reject(e) {
        if (void 0 === this.state) {
          this.state = n, this.v = e;
          var t = this.c;
          t && a(function () {
            for (var r = 0, a = t.length; r < a; r++) n(t[r], e);
          });
        }
      },
      then: function then(e, r) {
        var n = new t(),
          u = {
            y: e,
            n: r,
            p: n
          };
        if (void 0 === this.state) this.c ? this.c.push(u) : this.c = [u];else {
          var i = this.state,
            o = this.v;
          a(function () {
            i(u, o);
          });
        }
        return n;
      }
    }, t.resolve = function (e) {
      if (e && e instanceof t) return e;
      var r = new t();
      return r.resolve(e), r;
    }, t.reject = function (e) {
      if (e && e instanceof t) return e;
      var r = new t();
      return r.reject(e), r;
    }, t.version = "2.3.3-nodent", t;
  })());
  var a = this;
  switch (r) {
    case !0:
      return new e.Thenable(n);
    case 0:
      return new e.LazyThenable(n);
    case void 0:
      return n.then = n, n;
    default:
      return function () {
        try {
          return a.apply(t, arguments);
        } catch (e) {
          return r(e);
        }
      };
  }
};
var toNumber = _default([[_default2, _default3], [_default4(Number), _default3], [_default5, function (e) {
    return Number(e);
  }]]),
  isWithin = _default6(function (e, t, r) {
    var n = _default4(Number);
    return n(e) && n(t) && n(r) && _default7(r, e) && _default7(t, r);
  }),
  isInvalidConfig = _default8([_default2, _default9, _default10(_default11("baseURL")), _default10(_default12(String, "baseURL")), _default13(_default9, "baseURL")]),
  isPromise = function isPromise(e) {
    return !!e && ("object" === ("undefined" == typeof e ? "undefined" : _typeof(e)) || "function" == typeof e) && "function" == typeof e.then;
  },
  DEFAULT_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  DEFAULT_CONFIG = {
    timeout: 0
  },
  NONE = null,
  CLIENT_ERROR = "CLIENT_ERROR",
  SERVER_ERROR = "SERVER_ERROR",
  TIMEOUT_ERROR = "TIMEOUT_ERROR",
  CONNECTION_ERROR = "CONNECTION_ERROR",
  NETWORK_ERROR = "NETWORK_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  CANCEL_ERROR = "CANCEL_ERROR",
  TIMEOUT_ERROR_CODES = ["ECONNABORTED"],
  NODEJS_CONNECTION_ERROR_CODES = ["ENOTFOUND", "ECONNREFUSED", "ECONNRESET"],
  in200s = isWithin(200, 299),
  in400s = isWithin(400, 499),
  in500s = isWithin(500, 599),
  statusNil = _default14(_default2, _default15(void 0), _default16("status")),
  create = function create(e) {
    if (isInvalidConfig(e)) throw new Error("config must have a baseURL");
    var t = _default17(DEFAULT_HEADERS, e.headers || {}),
      r = _default17(DEFAULT_CONFIG, _default18("headers", e)),
      n = axios.create(r),
      a = [],
      u = function u(e) {
        a.push(e);
      },
      i = [],
      o = [],
      f = [],
      s = function s(e) {
        return i.push(e);
      },
      l = function l(e) {
        return o.push(e);
      },
      c = function c(e) {
        return f.push(e);
      },
      R = function R(e, r) {
        return t[e] = r, n;
      },
      d = function d(e) {
        return _default19(function (t) {
          return R(t, e[t]);
        }, _default20(e)), n;
      },
      _ = function _(e) {
        return delete t[e], n;
      },
      E = function E(e) {
        return n.defaults.baseURL = e, n;
      },
      p = function p() {
        return n.defaults.baseURL;
      },
      O = function O(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return N(_default17({
          url: t,
          params: r,
          method: e
        }, n));
      },
      h = function h(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return N(_default17({
          url: t,
          method: e,
          data: r
        }, n));
      },
      N = function N(e) {
        return new Promise(function (r, a) {
          function u() {
            function t() {
              return f;
            }
            return c < o.length ? (R = o[c](e), isPromise(R) ? R.then(function (e) {
              return t.call(this);
            }.$asyncbind(this, a), a) : R(e).then(function (e) {
              return t.call(this);
            }.$asyncbind(this, a), a)) : [1];
          }
          function f() {
            return c++, u;
          }
          function s() {
            return l.call(this);
          }
          function l() {
            return d = _default21(_default22(T, [toNumber(new Date())]), y), r(n.request(e).then(d).catch(d));
          }
          var c, R, d;
          return e.headers = _extends({}, t, e.headers), i.length > 0 && _default19(function (t) {
            return t(e);
          }, i), o.length > 0 ? (c = 0, Function.$asyncbind.trampoline(this, s, f, a, !0)(u)) : l.call(this);
        }.$asyncbind(this));
      },
      y = function y(e) {
        return a.forEach(function (t) {
          try {
            t(e);
          } catch (e) {}
        }), e;
      },
      T = function T(e, t) {
        var r = toNumber(new Date()),
          n = r - e,
          a = t instanceof Error || axios.isCancel(t),
          u = a ? t.response : t,
          i = u && u.status || null,
          o = a ? m(t) : v(i),
          s = in200s(i),
          l = t.config || null,
          c = u && u.headers || null,
          R = u && u.data || null,
          d = {
            duration: n,
            problem: o,
            ok: s,
            status: i,
            headers: c,
            config: l,
            data: R
          };
        return f.length > 0 && _default19(function (e) {
          return e(d);
        }, f), d;
      },
      m = function m(e) {
        return "Network Error" === e.message ? NETWORK_ERROR : axios.isCancel(e) ? CANCEL_ERROR : _default([[_default2, function () {
          return v(statusNil(e.response));
        }], [_default23(_default24, TIMEOUT_ERROR_CODES), _default15(TIMEOUT_ERROR)], [_default23(_default24, NODEJS_CONNECTION_ERROR_CODES), _default15(CONNECTION_ERROR)], [_default5, _default15(UNKNOWN_ERROR)]])(e.code);
      },
      v = function v(e) {
        return _default([[_default2, _default15(UNKNOWN_ERROR)], [in200s, _default15(NONE)], [in400s, _default15(CLIENT_ERROR)], [in500s, _default15(SERVER_ERROR)], [_default5, _default15(UNKNOWN_ERROR)]])(e);
      },
      D = {
        axiosInstance: n,
        monitors: a,
        addMonitor: u,
        requestTransforms: i,
        asyncRequestTransforms: o,
        responseTransforms: f,
        addRequestTransform: s,
        addAsyncRequestTransform: l,
        addResponseTransform: c,
        setHeader: R,
        setHeaders: d,
        deleteHeader: _,
        headers: t,
        setBaseURL: E,
        getBaseURL: p,
        get: _default22(O, ["get"]),
        delete: _default22(O, ["delete"]),
        head: _default22(O, ["head"]),
        post: _default22(h, ["post"]),
        put: _default22(h, ["put"]),
        patch: _default22(h, ["patch"]),
        link: _default22(O, ["link"]),
        unlink: _default22(O, ["unlink"])
      };
    return D;
  },
  apisauce = {
    DEFAULT_HEADERS: DEFAULT_HEADERS,
    NONE: NONE,
    CLIENT_ERROR: CLIENT_ERROR,
    SERVER_ERROR: SERVER_ERROR,
    TIMEOUT_ERROR: TIMEOUT_ERROR,
    CONNECTION_ERROR: CONNECTION_ERROR,
    NETWORK_ERROR: NETWORK_ERROR,
    UNKNOWN_ERROR: UNKNOWN_ERROR,
    create: create
  };
exports.DEFAULT_HEADERS = DEFAULT_HEADERS, exports.NONE = NONE, exports.CLIENT_ERROR = CLIENT_ERROR, exports.SERVER_ERROR = SERVER_ERROR, exports.TIMEOUT_ERROR = TIMEOUT_ERROR, exports.CONNECTION_ERROR = CONNECTION_ERROR, exports.NETWORK_ERROR = NETWORK_ERROR, exports.UNKNOWN_ERROR = UNKNOWN_ERROR, exports.CANCEL_ERROR = CANCEL_ERROR, exports.create = create, exports.default = apisauce;